import { LeadGenBannerSection, SectionListRendererWrapper } from './SectionListRenderer.styles';

import { ContentTypeMapping, ContentTypeName } from '@/constants';
import { useGlobalState } from '@/hooks';
import { ButtonFunctionKey } from '@/interfaces';
import { capitalize } from '@/utils';

interface ISectionListRendererProps {
  sectionList: any[];
  hideSpacingBetweenSections?: boolean;
}

const SectionListRenderer: React.FC<ISectionListRendererProps> = ({
  sectionList,
  hideSpacingBetweenSections,
}) => {
  const { isLoggedIn } = useGlobalState();
  return (
    <SectionListRendererWrapper hideSpacingBetweenSections={hideSpacingBetweenSections}>
      {sectionList.map((section, index) => {
        const SectionComponent = ContentTypeMapping[section.__typename as ContentTypeName];

        if (!SectionComponent) {
          return null;
        }

        switch (capitalize(section.__typename)) {
          case ContentTypeName['LeadGenBanner']: {
            const isPopUpButton = section?.buttons?.some((button: any) => button.function === ButtonFunctionKey.PopUp);
            const isHideLoggedInUser = isPopUpButton && isLoggedIn;
            return (
              // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
              <LeadGenBannerSection key={index} variant={section.variant} isHideLoggedInUser={isHideLoggedInUser}>
                <SectionComponent {...section} />
              </LeadGenBannerSection>
            );
          }

          default:
            // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
            return <SectionComponent key={index} {...section} />;
        }
      })}
    </SectionListRendererWrapper>
  );
};

export default SectionListRenderer;
